import React from 'react';
import { ReactComponent as ArrowRightDark }  from '../../../../assets/icons/arrow-right-dark.svg';
import Button, { ButtonProps } from '../Button';

function ButtonSecondary(props: ButtonProps) {
  return (
    <Button
      {...props}
      secondary
      icon={<ArrowRightDark/>}
    />
  )
}

export default ButtonSecondary;
